/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { CtbidsContentList, CtbidsContentEdit } from 'features/components/base/ctbids-content';
import { ShopWithAPurpose } from 'features/components/base/ctbids-content/ShopWithAPurpose';
import { NewsAndStories } from 'features/components/base/ctbids-content/NewsAndStories';
import MysteryRewards from 'features/components/base/ctbids-content/MysteryRewards';
import TermsAndConditions from 'features/components/base/ctbids-content/TermsAndConditions';
import { NewsAndStoriesList } from 'features/components/base/ctbids-content/NewsAndStoriesList';
import { PrivacyPolicy } from 'features/components/base/ctbids-content/PrivacyPolicy';

/**
 * routing for buyers components
 * 
 * @param props
 * 
 * @return routing for buyers components
 * 
**/

export class CtbidsContentRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={`/ctbids-content/list`} component={CtbidsContentList} />
                <Route exact path={'/ctbids-content/add'} component={CtbidsContentEdit} />
                <Route exact path={`/ctbids-content/edit/:contentId`} component={CtbidsContentEdit} />
                <Route exact path={`/ctbids-content/shop-with-a-purpose`} component={ShopWithAPurpose} />
                <Route exact path={`/ctbids-content/news-and-stories/list`} component={NewsAndStoriesList} />
                <Route exact path={[`/ctbids-content/news-and-stories/add`, `/ctbids-content/news-and-stories/edit/:id`, `/ctbids-content/news-and-stories/view/:id`,]} component={NewsAndStories} />
                <Route exact path={`/ctbids-content/mystery-rewards`} component={MysteryRewards} />
                <Route exact path={`/ctbids-content/privacy-policy`} component={PrivacyPolicy} />
                <Route exact path={`/ctbids-content/terms-and-conditions`} component={TermsAndConditions} />

                {
                    this.props.location.pathname === '/content' ? 
                    <Redirect to="/ctbids-content/list" /> : 
                    <Redirect to="/home" />
                }
            </Switch>
        );
    }
}